// extracted by mini-css-extract-plugin
module.exports = {"backButton":"FloatingButton_backButton__Fbj5F"};